import { render, staticRenderFns } from "./UpcomingAuctionsCard.vue?vue&type=template&id=6d72934d&scoped=true&"
import script from "./UpcomingAuctionsCard.vue?vue&type=script&lang=js&"
export * from "./UpcomingAuctionsCard.vue?vue&type=script&lang=js&"
import style0 from "./UpcomingAuctionsCard.vue?vue&type=style&index=0&id=6d72934d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d72934d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
